import React from "react";

import CardContent from "@material-ui/core/CardContent";

import { days } from "../../../utils/datesShortcut";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TimerIcon from "@material-ui/icons/Timer";
import TimerOffIcon from "@material-ui/icons/TimerOff";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CheckIcon from "@material-ui/icons/Check";
import useStyles from "../../../assets/cardStyles";

export default function ScheduleContentCard({ data }) {
	const classes = useStyles();
	return (
		<CardContent className={classes.content}>
			{data.scheduleOpens !== undefined && (
				<List>
					<ListItem>
						<ListItemIcon>
							<TimerIcon />
						</ListItemIcon>
						<ListItemText primary={data.scheduleOpens} />
					</ListItem>
					<ListItem>
						<ListItemIcon>
							<TimerOffIcon />
						</ListItemIcon>
						<ListItemText primary={data.scheduleCloses} />
					</ListItem>
				</List>
			)}
			<List>
				{data.availableDays.map((day) => (
					<ListItem key={day}>
						<ListItemIcon>
							<CheckIcon />
						</ListItemIcon>
						<ListItemText primary={days[day]} />
					</ListItem>
				))}
				{data.availableDays.length < 1 && <ListItem>No se agregó ningún día</ListItem>}
			</List>
		</CardContent>
	);
}
